import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';

export function useEventTimeRange() {
    const timeStart = useSelector((state: RootState) => state.event.timeStart);
    const timeEnd = useSelector((state: RootState) => state.event.timeEnd);

    const isWithin = useCallback((time: number): boolean => {
        if(timeStart == null || timeEnd == null) return true;
        return time >= timeStart && time <= timeEnd;
    }, [timeStart, timeEnd]);

    return {isWithin};
}
